import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { NotificationAddAction } from "../../Redux/Action/NotificationsAction";




interface FormInputs {
  title: string,
  description: string,
  receiver:string
}
function NotificationAdd() {
  const dispatch = useDispatch<any>();
  const notificationAdd = useSelector((state: any) => state.NotificationAddState);
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const navigate = useNavigate()
  const formSchema: any = Yup.object().shape({
    title: Yup.string()
      .required('Please enter title.')
      .trim()
      .min(2, 'Title  must be more than 2 characters.')
      .max(50, 'Title  should not exceed 50 characters.'),
      receiver: Yup.string()
      .required('Please select user type.')
      .trim(),
    description: Yup.string()
      .required('Please enter description.')
      .trim()
      .min(20, 'description  must be more than 20 characters.')
      .max(300, 'description  should not exceed 300 characters.'),
  });

  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data: FormInputs) => {
    dispatch(NotificationAddAction(data))
  };



  useEffect(() => {
    return () => {
      dispatch(NotificationAddAction('RESET'));
    }
  }, [])

  useEffect(() => {
    if (notificationAdd?.status) {
      navigate('/notifications')
    }
  }, [notificationAdd?.status])

  return (
    <Fragment>
      {log_in?.loading || notificationAdd.loading ? <Spinner /> : ""}
      <PageLayout
        title="Notification Add"
        breadcrumbs={{
          secLast: { 'link': '/notifications', 'name': 'Notification Management' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <div className="mt-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gy-4 mb-4">
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Title*</label>
                <input type="text" className="form-control mb-0" id="username" placeholder="Enter title" {...register("title", {
                  required: "Please enter title.",

                })}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="username" className="form-label">Description*</label>
                <textarea className="form-control mb-0" id="username" placeholder="Enter description" {...register("description", {
                  required: "Please enter description.",
                })}
                />
                <ErrorMessage
                  errors={errors}
                  name="description"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="status" className="form-label">User Type*</label>
                <select  id="approved" className="form-control profile-approve-dropdown" {...register("receiver")}  >
                <option value="">Select user type</option>
                  <option value="1"  >All user</option>
                  <option value="2" >All customer user</option>
                  <option value="3" >All salon</option>
                </select>
                <ErrorMessage
                  errors={errors}
                  name="receiver"
                  render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                />
              </div>
              <div className="col-md-2" style={{marginTop:'52px'}}>
                <button type="submit" className="btn btn-primary waves-effect waves-light w-100">SAVE</button>
              </div>
            </div>

          </form>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}


export default NotificationAdd